import {defineStore} from 'pinia';
import {AVAILABLE_CONTEXTS} from "@/api/QRCodeService";

export const useQrCodeDebugStore = defineStore('qrcodeDebug', {
  state: () => ({
    isDebugContextCodeActive: false,
    isDebugCountryCodeActive: false,
    contextCode: AVAILABLE_CONTEXTS.DEFAULT,
    countryCode: 'GB',
  }),
  getters: {
    getAvailableContextCodes() {
      return Object.values(AVAILABLE_CONTEXTS).map((value) => {
        return value;
      });
    },
  },
  actions: {
    setContextCode(contextCode: AVAILABLE_CONTEXTS) {
      this.contextCode = contextCode;
    },
    setCountryCode(countryCode: string) {
      this.countryCode = countryCode;
    },
  },
});
